import classNames from 'classnames'
import { useEffect } from 'react'

import style from './style.scss'

type Props = {
  className?: string
  iconLabelText: string
  url: string
  variant?: 'light' | 'dark'
}

function TwitterSharingIcon({
  className,
  iconLabelText,
  url,
  variant = 'dark',
}: Props) {
  useEffect(() => {
    const scriptTag = document.createElement('script')
    scriptTag.src = 'https://platform.twitter.com/widgets.js'
    scriptTag.async = true

    if (document.body) {
      document.body.appendChild(scriptTag)
    }

    return () => {
      scriptTag.remove()
    }
  }, [])
  return (
    <a
      className={classNames(
        style.wrapper,
        variant && style[variant],
        className,
      )}
      href={`https://twitter.com/intent/tweet?url=${encodeURIComponent(url)}`}
    >
      <span>{iconLabelText}</span>
    </a>
  )
}

export default TwitterSharingIcon
